import { render, staticRenderFns } from "./CreateOfferRequest.vue?vue&type=template&id=064dc6bc&scoped=true"
import script from "./CreateOfferRequest.vue?vue&type=script&lang=ts"
export * from "./CreateOfferRequest.vue?vue&type=script&lang=ts"
import style0 from "./CreateOfferRequest.vue?vue&type=style&index=0&id=064dc6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064dc6bc",
  null
  
)

export default component.exports